<div class="flex flex-col h-full w-full justify-start items-start gap-6 pb-6 bg-[#FFF]">
  <app-loi-check-stepper #stepper (selectedStepChange)="navigateToBaseCheckReport()" [nextStepAllowed]="true" [previousStepAllowed]="true"
                         [selectedStep]="1"
                         [detailCheckLabel]="'IDS-Check'"
                         class="w-full"></app-loi-check-stepper>
    <div class="w-full px-6">
      <app-overview-reports (download)="downloadReport()"
                            [activateDownload]="!loading"
                            (open)="openPressed()"
                            [activateOpen]="!loading"
                            [checkerName]="checkerName"
                            [completedValue]="idsCheckResult.score * 100"
                            [singleResult]="overallResult"
                            [date]="$safeNavigationMigration(check?.checkDate)"
                            [fileId]="check?.projectFile?.id ?? ''"
                            [info1]="fileSize"
                            [info2]="fileName"
                            [rules]="ruleName"
                            [loading]="loading"
                            checkType="LOI"
                            class="w-full">
      </app-overview-reports>
    </div>
    <div class="flex w-full flex-1 min-h-0 overflow-hidden px-6">
      <bic-result>
        <bic-result-column #specificationsColumn [(selectedElement)]="selectedSpecification" [alwaysFixed]="true"
                           [style.flex]="'50 1 0%'" [style.max-width]="'100%'" [style.min-width]="'0'">
          <bic-result-header header>
            <div class="w-full flex flex-row justify-between items-center gap-4 pl-8 pr-8">
              <div class="flex-1 min-w-0">
                Spezifikation
              </div>
              <div class="flex-1 min-w-0">
                Anwendbarkeit
              </div>
              <div class="w-32 text-center flex-shrink-0">
                Bauteile
              </div>
              <div class="w-32 text-center flex-shrink-0">
                Ergebnis
              </div>
            </div>
          </bic-result-header>

          @if (loading) {
            <bic-result-row [disableTasks]="true" [hidden]="true"></bic-result-row>
            <div class="flex flex-col flex-1 h-full justify-center items-center py-16">
              <div class="flex flex-row items-center gap-2">
                <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
                <span class="text-sm font-medium text-gray-500">Ergebnisse werden geladen...</span>
              </div>
            </div>
          } @else {
          @for (specification of idsCheckResult.specifications; track specification) {
            <bic-result-row [value]="specification"
                            [status]="specification.status ? 'success' : 'error'"
                            (taskClicked)="createTaskForSpecification(specification)">
              <div class="w-full flex flex-row justify-between items-center gap-4">
                <div class="flex-1 min-w-0">
                  {{ specification.name }}
                </div>

                <div #applicabilityContainer class="flex-1 min-w-0 flex flex-row items-center gap-2 overflow-hidden">
                  @for (app of specification.applicabilities; track $index) {
                    <bic-badge>{{ app.facetTypeLabel }}: {{ app.value ?? app.values?.[0] }}</bic-badge>
                  }
                  <span class="overflow-counter text-xs font-medium text-gray-700 flex-shrink-0"
                        style="display: none"></span>
                </div>

                <div class="w-32 text-center flex-shrink-0">
                  {{ specification.totalElements }}
                </div>

                <div class="w-32 text-center flex-shrink-0">
                  {{ specification.result * 100 | number:'1.0-0' }} %
                </div>
              </div>
            </bic-result-row>
          }
          }
        </bic-result-column>
        <bic-result-column [grouped]="true" [style.flex]="'50 1 0%'"
                           [style.max-width]="'100%'" [style.min-width]="'0'" emptyText="Bitte Spezifikation auswählen">
          <bic-result-header header>
            <div class="w-full flex flex-row justify-between min-w-0 items-center gap-4 pl-8">
              <div class="flex-1 min-w-0">
                Facette
              </div>

              <div class="flex-1 min-w-0">
                Name
              </div>

              <div class="flex-1 min-w-0">
                Wert
              </div>

              <div class="w-32 text-center flex-shrink-0">
                Ergebnis
              </div>
            </div>
          </bic-result-header>

          @if (selectedSpecification) {
            @for (requirement of selectedSpecification.requirements; track $index) {
              <bic-result-row [status]="requirement.status ? 'success' : 'error'"
                              (taskClicked)="createTaskForRequirement(requirement)" [grouped]="true">
                <div class="w-full flex flex-row justify-between items-center gap-4">
                  <div class="flex-1 min-w-0 truncate">
                    {{ requirement.facetType }}
                  </div>

                  <div class="flex-1 min-w-0 truncate">
                    {{ requirement.name }}
                  </div>

                  <div #valueContainer class="flex-1 min-w-0 flex flex-row items-center gap-2 overflow-hidden">
                    @if (requirement.values && requirement.values.length > 0) {
                      @for (val of requirement.values; track $index) {
                        <bic-badge>{{ val }}</bic-badge>
                      }
                    } @else {
                      <bic-badge>{{ requirement.cardinality === 'required' ? 'Erforderlich' : 'Optional' }}</bic-badge>
                    }
                    <span class="overflow-counter text-xs font-medium text-gray-700 flex-shrink-0"
                          style="display: none"></span>
                  </div>

                  <div class="w-32 text-center flex-shrink-0">
                    {{ requirement.result * 100 | number:'1.0-0' }} %
                  </div>
                </div>
              </bic-result-row>
            }
          }
        </bic-result-column>
      </bic-result>
    </div>

</div>
